import { testimonials } from "@/mocks/gua";
import SectionTitle from "./SectionTitle";

const principles = [
  {
    icon: "ri-user-heart-line",
    tone: "bg-primary-100 text-primary-700",
    title: "我们是做什么的",
    desc: "面向爱追热点但时间有限的你，把分散在社交平台、媒体和官方渠道的近期热门事件集中梳理，用最短时间补上最关键的瓜。",
  },
  {
    icon: "ri-shield-check-line",
    tone: "bg-accent-100 text-accent-700",
    title: "我们怎么做内容",
    desc: "不靠标题党博眼球，每条内容标注信息来源；事件尚不明朗时注明“持续跟进”，涉及人物叙述克制克制再克制，尽量不煽动、不传播未经证实的揣测。",
  },
  {
    icon: "ri-compass-3-line",
    tone: "bg-secondary-100 text-secondary-900",
    title: "我们想成为什么",
    desc: "既是“快速补课的入口”，也想陪大家做一个更理性的吃瓜人：看得明白来源，追得清楚脉络，评论得有理有据。",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-10 px-4 md:px-6">
        <SectionTitle
          eyebrow="吃瓜指南"
          title="关于最新吃瓜，先聊清楚这三件事"
          desc="网站怎么定位、内容怎么做、最终想成为什么——把它讲明白，你才能放心在这补课。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {principles.map((p) => (
            <article key={p.title} className="flex flex-col gap-4 rounded-2xl bg-white p-6">
              <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${p.tone}`}>
                <i className={`${p.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="font-heading text-lg font-black text-foreground-900">{p.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </article>
          ))}
        </div>

        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-2">
            <i className="ri-chat-quote-fill text-2xl text-primary-500" aria-hidden="true" />
            <h3 className="font-heading text-lg font-black text-foreground-900">来看看大家怎么说</h3>
          </div>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col gap-3 rounded-2xl bg-white p-6">
                <div className="flex gap-1 text-secondary-500">
                  <i className="ri-star-fill" aria-hidden="true" />
                  <i className="ri-star-fill" aria-hidden="true" />
                  <i className="ri-star-fill" aria-hidden="true" />
                  <i className="ri-star-fill" aria-hidden="true" />
                  <i className="ri-star-fill" aria-hidden="true" />
                </div>
                <blockquote className="flex-1 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="flex items-center gap-3 border-t border-background-100 pt-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 font-heading text-sm font-black text-accent-800">
                    {t.name.slice(0, 1)}
                  </span>
                  <div className="flex flex-col">
                    <span className="text-sm font-bold text-foreground-900">{t.name}</span>
                    <span className="text-xs text-foreground-500">{t.role}</span>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}